export class Disposable {
    constructor() {
        this._disposes = [];
        this.disposed = false;
        this.dispose = async () => {
            this.disposed = true;
            await Promise.all(this._disposes.map(async (dispose) => {
                try {
                    await dispose();
                }
                catch (err) {
                    console.error('Error disposing', err);
                }
            }));
            this._disposes = [];
        };
        this.compose = (disposable) => this.addDispose(disposable.dispose.bind(disposable));
        this.addDispose = (dispose) => {
            this._disposes.push(dispose);
        };
    }
}
//# sourceMappingURL=Disposable.js.map